<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Start Time" prop="beginTime" >
        <a-input v-model="form.beginTime" placeholder="Please enter start time" />
      </a-form-model-item>
      <a-form-model-item label="End Time" prop="endTime" >
        <a-input v-model="form.endTime" placeholder="Please enter end time" />
      </a-form-model-item>
      <a-form-model-item label="Price" prop="prices" >
        <a-input-number
          v-model="form.prices"
          :min="0"
          :step="0.01"
          :precision="2"
          style="width: 100%"
          placeholder="Please enter price"
        />
      </a-form-model-item>
      <a-form-model-item label="Sort (Ascending)" prop="sort" >
        <a-input v-model="form.sort" placeholder="Please enter sort order" />
      </a-form-model-item>
      <a-form-model-item label="Weekday" prop="weekDay" >
        <a-select
          v-model="form.weekDay"
          placeholder="Please select weekday"
          :mode="formType === 1 ? 'multiple' : 'default'"
        >
          <a-select-option v-for="day in weekOptions" :key="day" :value="day">{{ day }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPitchPrice, addPitchPrice, updatePitchPrice } from '@/api/golf/pitchPrice'

export default {
  name: 'CreateForm',
  props: {
    pitchId: {
      type: [String, Number],
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,

        beginTime: null,

        endTime: null,

        prices: null,

        pitchId: null,

        sort: null,

        weekDay: null,

        createTime: null,

        remark: null,

      },
      formType: 1,
      open: false,
      rules: {
        beginTime: [
          { required: true, message: 'Start time is required', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: 'End time is required', trigger: 'blur' }
        ],
        prices: [
          { required: true, message: 'Price is required', trigger: 'change' }
        ],
        weekDay: [
          { required: true, message: 'Weekday is required', trigger: 'change' }
        ]
      },
      weekOptions: [1, 2, 3, 4, 5, 6, 7],
      currentPitchId: null
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
    pitchId: {
      handler (val) {
        this.currentPitchId = val
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        beginTime: null,
        endTime: null,
        prices: null,
        pitchId: this.currentPitchId,
        sort: null,
        weekDay: [],
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd (pitchId) {
      this.reset()
      this.currentPitchId = pitchId !== undefined && pitchId !== null ? pitchId : this.pitchId
      this.form.pitchId = this.currentPitchId
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getPitchPrice({"id":id}).then(response => {
        this.form = response.data
        this.currentPitchId = this.pitchId
        this.form.pitchId = this.pitchId
        this.form.weekDay = Number(this.form.weekDay) || 1
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePitchPrice(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            const weekDays = Array.isArray(this.form.weekDay) ? this.form.weekDay : []
            const requests = weekDays.map(day => {
              return addPitchPrice({
                ...this.form,
                weekDay: day
              })
            })
            Promise.all(requests).then(() => {
              this.$message.success(
                'Added successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
